import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';

/** Mobile padding-bottom (default — not directly before Embed Panel). */
const SPLIT_HEADING_PADDING_BOTTOM_BASE = '32px';

/** Desktop (md+) padding-bottom below split heading. */
const SPLIT_HEADING_PADDING_BOTTOM_MD = '37px';

const helpers = createMultiStyleConfigHelpers([
  'container',
  'leftRegion',
  'rightRegion',
  'headingLeft',
  'textRight',
]);

/**
 * Split Heading (standalone block) styles
 *
 * Padding-bottom tokens: `SPLIT_HEADING_PADDING_BOTTOM_BASE` (mobile default),
 * `SPLIT_HEADING_PADDING_BOTTOM_MD` (desktop; also when mobile stacks before Embed Panel).
 */
export const splitHeadingStyles = helpers.defineMultiStyleConfig({
  baseStyle: () => ({
    container: {
      flexDirection: {base: 'column', lg: 'row'},
      justifyContent: {base: 'flex-start', lg: 'space-between'},
      gap: {base: '12px', lg: '150px'},
      paddingTop: {base: '32px', lg: '85px'},
      paddingBottom: {base: SPLIT_HEADING_PADDING_BOTTOM_BASE, md: SPLIT_HEADING_PADDING_BOTTOM_MD},
      paddingLeft: {base: '20px', lg: '80px'},
      paddingRight: {base: '20px', lg: '80px'},
      alignItems: {base: 'stretch', lg: 'flex-start'},
      maxWidth: '1440px',
      margin: '0 auto',
      boxSizing: 'border-box',

      sx: {
        '&:has(+ .component--embed-panel)': {
          paddingBottom: {base: 0, lg: SPLIT_HEADING_PADDING_BOTTOM_MD},
        },
        '&.split-heading--right-blank': {
          justifyContent: {base: 'flex-start', lg: 'flex-start'},
          gap: {base: '16px', lg: '36px'},
        },
      },
    },
    leftRegion: {
      className: 'split-heading__left-region',
      flex: {base: '0 0 auto', lg: '1 1 0%'},
      minWidth: 0,
    },
    rightRegion: {
      className: 'split-heading__right-region',
      flex: {base: '0 0 auto', lg: '0 0 620px'},
      width: {base: '100%', lg: '620px'},
      maxWidth: {base: '100%', lg: '620px'},
      paddingTop: {base: 0, lg: '8px'},
    },
    headingLeft: {
      className: 'split-heading__heading',
      fontFamily: 'body',
      fontVariantNumeric: 'lining-nums proportional-nums',
      textAlign: 'left',
      color: 'brandColors.greyscale90',
    },
    textRight: {
      className: 'split-heading__description',
      fontFamily: 'body',
      fontVariantNumeric: 'lining-nums proportional-nums',
      fontWeight: 400,
      textAlign: 'left',
      color: 'brandColors.greyscale90',
    },
  }),
  variants: {
    large: () => ({
      headingLeft: {
        fontSize: {base: '28px', md: '40px'},
        fontWeight: {base: 500, md: 400},
        lineHeight: {base: '120%', md: '100%'},
        letterSpacing: {base: '-0.4px', md: '-0.72px'},
      },
      textRight: {
        fontSize: {base: '16px', md: '20px'},
        lineHeight: {base: '160%', md: '150%'},
      },
    }),
    medium: () => ({
      headingLeft: {
        fontSize: {base: '24px', md: '32px'},
        fontWeight: 500,
        lineHeight: 1.2,
        letterSpacing: '-0.01em',
      },
      textRight: {
        fontSize: {base: '16px', md: '20px'},
        lineHeight: {base: '160%', md: '150%'},
      },
    }),
  },
  defaultProps: {
    variant: 'large',
  },
});
